/**
 * Number-formatting helpers shared across the app.
 *
 * `formatCompactNaira` — rounds down to the nearest 100 K and adds a `+`
 * suffix so a 13-digit lifetime-paid stat doesn't overflow narrow columns
 * on the landing page. Use ONLY for large aggregate marketing stats;
 * never for a worker's own wallet balance or per-task reward (they need
 * exact figures).
 */

export function formatCompactNaira(n) {
  const v = Number(n) || 0;
  if (v < 1000) return `₦${v}`;
  if (v < 1_000_000) {
    const k = Math.floor(v / 100) / 10;
    return `₦${k}K+`;
  }
  if (v < 1_000_000_000) {
    const m = Math.floor(v / 100_000) / 10;
    return `₦${m}M+`;
  }
  const b = Math.floor(v / 100_000_000) / 10;
  return `₦${b}B+`;
}
